import {
  cargoTypeNeedsTemperature,
  ERR_CANNOT_DELETE_STOP_WITH_EVENTS,
  ERR_DELETED_EXTRA_CO2_TYPES,
  ERR_OUTDATED_CARGO_REVISION,
  isNotNullOrUndefined,
} from "dora-shared";
import { ERR_CARGO_ALREADY_DELETED } from "dora-contracts";
import { Dialog, Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./index.scss";
import {
  faExclamationTriangle,
  faPlus,
  faTimes,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import {
  DoraButton,
  UFDoraSelect,
  UFDoraTextInput,
  UFDoraNumberInput,
  UFDoraSelectMultiple,
  UFDoraCheckbox,
  UFDoraTextArea,
} from "dora-shared/frontend";
import { UFDoraMultilineTextAutocomplete } from "../../Toolkit/DoraMultilineTextAutocomplete";
import { loadAutocompleteSuggestions } from "../../../ducks/data/autocomplete-suggestions";
import CreateEditShipmentFinancesAndDrivingReportCard from "./finances/CreateEditShipmentFinancesAndDrivingReportCard";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  FormProvider,
  useFieldArray,
  useForm,
  useWatch,
} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import getValidationSchema from "./create-edit-shipment-validation-schema";
import StopList from "./stops/StopList";
import { DateTime } from "luxon";
import { useAppDispatch, useSelector } from "../../../redux-store";
import { getClients } from "../../../ducks/data/clients";
import { useTranslation } from "react-i18next";
import CreateShipmentData from "./CreateEditShipmentData";
import { nanoid } from "nanoid";
import GenericPromptDialog from "../GenericPromptDialog/GenericPromptDialog";
import {
  DELETED_EXTRA_CO2_TYPES_DECLINED,
  useConfirmDropDeletedExtraCo2Types,
} from "../ConfirmDropDeletedExtraCo2Types";
import DocumentsCard from "./documents/DocumentsCard";
import EquipmentSelect from "./equipment/EquipmentSelect";
import {
  CargoData,
  CargoFormData,
} from "../../../ducks/app/cargo-dialog/types";
import { selectCustomerContacts } from "../../../ducks/data/economics/customer-contacts/selectors";
import * as actions from "../../../ducks/data/economics/customer-contacts";
import { loadCustomerDeliveryLocations } from "../../../ducks/data/economics/customer-delivery-locations";
import { useFocusCustomer } from "../../../ducks/data/economics/customer-delivery-locations/use-focus-customer";
import { useNavigate, useLocation } from "react-router-dom";
import { ContactPersonData } from "./components/ContactPerson";
import CargoEventsShipment from "./components/CargoEventsShipment";
import ClientContactSelect from "./components/ClientContactSelect";
import MailSourceCard from "./components/MailSourceCard";
import ScanReadingsCard from "./components/ScanReadingsCard";
import useShipmentFormSelectOptions from "./use-shipment-form-select-options";
import { getEstimatedDistanceForCoords } from "../../../api";
import axios from "../../../axios";
import ClientSelect from "./ClientSelect";
import { selectClients } from "../../../ducks/data/clients/selectors";
import CargoTagSelect from "./CargoTagSelect";
import { useFeature } from "../../../hooks";
import { loadCargo } from "../../../ducks/app/cargo-dialog";
import { loadScheduleCargoTemplate } from "../../../ducks/app/schedule-cargo-template-dialog";
import { loadCargoTemplate } from "../../../ducks/app/client-cargo-template-dialog";
import WeightEventsTotalWeightAndTimeSpent from "./components/WeightEventsTotalWeightAndTimeSpent";
import WeightEventsErrorBoundary from "./components/WeightEventsErrorBoundary";
import ScrollNavigationTabs from "./ScrollNavigationTabs";
import useCargoEvents from "./use-cargo-events";
import { Stop } from "../../../ducks/app/cargo-and-template-shared";
import { loadExtraCO2Types } from "../../../ducks/data/extra-co2-types";
import {
  selectExtraCO2Types,
  selectLiveExtraCO2Types,
} from "../../../ducks/data/extra-co2-types/selectors";
import Decimal from "decimal.js-light";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import ShipmentDialogClientInfoMailLinks from "./components/ShipmentDialogClientInfoMailLinks";
import useShipmentFormRules from "./use-shipment-form-rules";
import {
  selectClientRequiredOnCargos,
  selectDriverCanAddStopsDefaultSetting,
  selectDriverCanPickFromUndispatchedDefaultSetting,
  selectDriverShouldRegisterTimeDefaultSetting,
  selectHideCargoFromDriversDefaultSetting,
  selectEquipmentEnabled,
  selectHideLoadmeters,
} from "../../../ducks/data/org-settings/selectors";
import {
  selectDefaultCopyOption,
  selectDefaultCreateCopyOption,
} from "../../../ducks/data/user-settings/selectors";
import RouteRoadToll from "./components/RouteRoadToll";
import {
  selectPricingAgreementsForClient,
  selectProducts,
  selectProductsForDispatcherTeamProductGroups,
} from "../../../ducks/data/products/selectors";
import useCreateInvoiceLinesOnSelectedProducts from "./use-create-invoice-lines-on-selected-products";
import useCalculateEstimatedShipmentDistance from "./use-calculate-estimated-shipment-distance";
import useShipmentFormSelectTeamRelatedOptions from "./use-shipment-form-select-team-related-options";
import DuplicateCargoDropdown from "./components/DuplicateCargoDropdown";
import CreateCargoCopyDropdown from "./components/CreateCargoCopyDropdown";
import CopyCargoToDriverRoutesDialog from "./components/CopyCargoToDriverRoutesDialog";
import CreateCargoOnDriverRoutesDialog from "./components/CreateCargoOnDriverRoutesDialog";
import ClientCargoTemplateButtonsAndModal from "./components/ClientCargoTemplateButtonsAndModal";
import ClientCargoTemplateSelect from "./components/ClientCargoTemplateSelect";
import ProductsChipSelect from "./components/ProductsChipSelect";
import ManageClientCargoTemplates from "./components/ManageClientCargoTemplates";
import { mapFormStopToAPIFormat } from "./map-form-stop-to-api-format";
import { reconcileHiddenDropoffLoadmeters } from "./stops/reconcile-hidden-dropoff-loadmeters";
import {
  adoptSavedStopIds,
  hasRowsAwaitingIds,
} from "./stops/adopt-saved-stop-ids";
import { CargoModalEntityType } from "./CargoModalEntityType";
import { clearSelectedTemplate } from "../../../ducks/data/client-order-templates";
import {
  draftLinesCleared,
  draftLinesQuantitiesReset,
} from "../../../ducks/data/draft-invoice-lines";
import { selectCurrentOrderTemplate } from "../../../ducks/data/client-order-templates/selectors";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AddClientButtonAndModal from "./components/AddClientButtonAndModal";
import SelectedClientDetails from "./components/SelectedClientDetails";
import cargoTypeNeedsContainerNo from "./cargo-type-needs-container-no";
import { loadStopUnitTemplatesAndTeams } from "../../../ducks/data/stop-unit-templates";
import ContractorInfoSection from "./components/ContractorInfoSection";
import SharedFromOrg from "./components/SharedFromOrg";
import DeletedCargoBanner from "./components/DeletedCargoBanner";
import RemoteChangesConflictBanner from "./components/RemoteChangesConflictBanner";
import { useOpenCargoSync } from "./use-open-cargo-sync";
import { sameValue } from "./merge-remote-changes";
import {
  cargoSyncSource,
  loadedRevisionOf,
  openCargoSyncSource,
} from "./open-cargo-sync-sources";
import { loadCargoSplitsForCargo } from "../../../ducks/data/cargos-splits-info";
import CargoEventsShipmentSplits from "./components/CargoEventsShipmentSplits";
import { loadProductGroups } from "../../../ducks/data/teams";
import { selectFinanceConfiguration } from "../../../ducks/data/finance/selectors";

type CreateEditShipmentDialogProps = {
  onClose: (data: { formData?: CargoFormData; cargoId?: string }) => void;
  isSaving: boolean;
  onSubmit: (
    data: CargoFormData & {
      keepAlive?: boolean;
      submitType: "CREATE" | "UPDATE" | "DUPLICATE" | "CREATE_AND_MAKE_COPY";
      cargoIdToCopyInvoiceLinesFrom: string | null;
      cargoIdToCopyFilesFrom: string | null;
      resetInvoiceLineQuantities?: boolean;
      // Set once the user agreed to save without the lines whose type was
      // deleted, after a first attempt came back ERR_DELETED_EXTRA_CO2_TYPES.
      dropDeletedExtraCo2Types?: boolean;
    }
  ) => Promise<{ id?: string; keepAlive?: boolean; error?: string }>;
  onDelete: () => void | Promise<void>;
  initialData: CargoData;
  resetData: CargoData;
  routeId?: string;
  createNew: boolean;
  entityType: CargoModalEntityType;
  clientIdForTemplate?: string;
  // True when initialData was restored from a redux cache rather than freshly
  // loaded (see AddEditCargo.tsx) — its stops may reference stops that were
  // deleted elsewhere since it was cached, so per-stop document fetches
  // should tolerate a "stop not found" error instead of surfacing it.
  initialDataFromCache?: boolean;
  // Someone else deleted this cargo while it was open: it can't be saved or
  // deleted any more, only duplicated as a new one (DORA-458).
  deleted?: boolean;
};

// Not JSON.stringify: the initial coords and the form's coords list lat/lon
// in different key orders.
const coordsToKey = (coords: { lat: number; lon: number }[]) =>
  coords.map((c) => `${c.lat},${c.lon}`).join(";");

export default function CreateEditShipmentDialog(
  props: CreateEditShipmentDialogProps
) {
  const { t } = useTranslation([
    "components",
    "types",
    "shipmentModal",
    "orderTemplates",
    "extraCO2Types",
  ]);
  const {
    routeId,
    onClose,
    onSubmit,
    onDelete,
    isSaving,
    initialData,
    resetData,
    createNew,
    entityType,
    clientIdForTemplate,
    initialDataFromCache,
    deleted = false,
  } = props;
  const [routeRef, setRouteRef] = useState(null);
  const [truckNumber, setTruckNumber] = useState<string | null>(null);
  const [trailerNumber, setTrailerNumber] = useState<string | null>(null);
  const [
    shouldShowConfirmUpdateCargoDeleteStops,
    setShouldShowConfirmUpdateCargoDeleteStops,
  ] = useState(false);
  const [
    shouldShowOutdatedRevisionDialog,
    setShouldShowOutdatedRevisionDialog,
  ] = useState(false);
  const {
    ask: askToDropDeletedExtraCo2Types,
    dialog: dropDeletedExtraCo2TypesDialog,
  } = useConfirmDropDeletedExtraCo2Types("SAVE");
  const [
    shouldShowExitWithoutSavingWarning,
    setShouldShowExitWithoutSavingWarning,
  ] = useState(false);

  const userId = initialData.userId || null;
  const cargoCreatedAt = initialData.createdAt || null;

  // canBeDeleted and deliveryId only apply to cargo, not to cargo template
  const [canBeDeleted, setCanBeDeleted] = useState(
    "canBeDeleted" in initialData ? initialData.canBeDeleted : true
  );
  // Locked when the status was set by an actual invoice being sent (a copied
  // cargo starts fresh, so ignore the flag when creating).
  const [invoiceStatusLocked, setInvoiceStatusLocked] = useState(
    !createNew &&
      "invoiceStatusLocked" in initialData &&
      !!initialData.invoiceStatusLocked
  );
  const [deliveryId, setDeliveryId] = useState(
    "deliveryId" in initialData ? initialData.deliveryId : null
  );

  const [id, setId] = useState(initialData.id || null);

  const selectedTemplate = useSelector(selectCurrentOrderTemplate);

  useEffect(() => {
    const shipmentId = initialData.id;
    if (entityType === CargoModalEntityType.CARGO && shipmentId) {
      axios
        .get(`/api/cargos/${shipmentId}/route-ref`)
        .then((res) => setRouteRef(res.data.routeRef))
        .catch((err) => console.error("Unable to load route ref", err));
      axios
        .get(`/api/cargos/${shipmentId}/route-vehicle-numbers`)
        .then((res) => {
          setTruckNumber(res.data.truckNumber ?? null);
          setTrailerNumber(res.data.trailerNumber ?? null);
        })
        .catch((err) =>
          console.error("Unable to load route vehicle numbers", err)
        );
    }
  }, [initialData, entityType]);

  const navigate = useNavigate();
  const location = useLocation();
  const [customerContactId, setCustomerContactId] = useState<string | null>(
    initialData.customerContactId
  );
  const [duplicateInProgress, setDuplicateInProgress] = useState(false);
  const [createCopyInProgress, setCreateCopyInProgress] = useState(false);
  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const [shouldShowConfirmDeleteDialog, setShouldShowConfirmDeleteDialog] =
    useState(false);
  const [copyToRoutesDialogOpen, setCopyToRoutesDialogOpen] = useState(false);
  const [createOnDriverRoutesDialogOpen, setCreateOnDriverRoutesDialogOpen] =
    useState(false);
  const [createOnDriverRoutesFormData, setCreateOnDriverRoutesFormData] =
    useState<CargoData | null>(null);
  const [estimatedDistance, setEstimatedDistance] = useState<number | null>(
    null
  );
  const [shouldShowTemperatureInput, setShouldShowTemperatureInput] =
    useState(false);
  const [shouldShowContainerNoInput, setShouldShowContainerNoInput] =
    useState(false);
  const [
    dropoffAccumulatedInputsDisabled,
    setDropoffAccumulatedInputsDisabled,
  ] = useState(false);
  const [shouldShowClientSelect, setShouldShowClientSelect] = useState(true);
  const [shouldShowContactSelect, setShouldShowContactSelect] = useState(true);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (initialData.customerContactId) {
      setCustomerContactId(initialData.customerContactId);
    }
  }, [setCustomerContactId, initialData]);
  useEffect(() => {
    if (initialData.clientId) {
      dispatch(actions.loadCustomerContacts(initialData.clientId));
      dispatch(loadCustomerDeliveryLocations(initialData.clientId));
    }
    dispatch(getClients());
    dispatch(loadExtraCO2Types());
    dispatch(loadAutocompleteSuggestions());
  }, [dispatch, initialData]);
  useCargoEvents({ cargoId: id, entityType });

  useEffect(() => {
    if (id && entityType === CargoModalEntityType.CARGO) {
      dispatch(loadCargoSplitsForCargo(id));
    }
  }, [dispatch, id, entityType]);

  // TODO: get from fetched data instead
  const cargoIsSplit = true;

  const splitFeatureEnabled = useFeature("split-cargos-and-routes");
  const copyToDriverRoutesEnabled = useFeature("copy-cargo-to-driver-routes");

  const shouldShowCargoEventsForSplits = useMemo(
    () => cargoIsSplit && splitFeatureEnabled,
    [cargoIsSplit, splitFeatureEnabled]
  );

  const products = useSelector(selectProducts);
  const dispatcherVisibleProducts = useSelector(
    selectProductsForDispatcherTeamProductGroups
  );

  const clients = useSelector(selectClients);
  const extraCo2Types = useSelector(selectExtraCO2Types);
  const liveExtraCo2Types = useSelector(selectLiveExtraCO2Types);
  const driverShouldRegisterTime = useSelector(
    selectDriverShouldRegisterTimeDefaultSetting
  );
  const hideCargoFromDriversDefault = useSelector(
    selectHideCargoFromDriversDefaultSetting
  );
  const driverCanAddStopsDefault = useSelector(
    selectDriverCanAddStopsDefaultSetting
  );
  const driverCanPickFromUndispatchedDefault = useSelector(
    selectDriverCanPickFromUndispatchedDefaultSetting
  );
  const clientRequiredOnCargos = useSelector(selectClientRequiredOnCargos);
  const equipmentEnabled = useSelector(selectEquipmentEnabled);
  const hideLm = useSelector(selectHideLoadmeters);
  const defaultCopyOption = useSelector(selectDefaultCopyOption);
  const defaultCreateCopyOption = useSelector(selectDefaultCreateCopyOption);

  const serverAutocompleteEnabled = useFeature(
    "user-shipment-fields-autocomplete-from-server"
  );
  const driverRegisterTimeEnabled = useFeature("driver-cargo-time-register");
  const driverCreateDropdownsCheckboxEnabled = useFeature(
    "driver-create-dropdowns-dispatchers-cargo"
  );
  const liteVersion = useFeature("lite-version");
  const stopTimeRequired = useFeature("stop-sort-time-required");
  const shareCargoEnabled = useFeature("orgs-subcontracting");
  const newStopUnitsEnabled = useFeature("DO NOT TOUCH new-stops-units");
  const isEconomicProductGroupsEnabled = useFeature("economic-product-groups");
  // These two cards are the whole UI for their features: with the feature off
  // they have nothing to show and nothing to fetch, so they are kept out of
  // the tree entirely rather than mounting and returning null.
  const mailOrdersEnabled = useFeature("mail-orders");
  const scanReadingsEnabled = useFeature("scan-readings");
  const manyToManyEnabled = useFeature("pickups-dropoffs-many-to-many");
  const financeConfig = useSelector(selectFinanceConfiguration);
  const productsGroupsEnabled = useMemo(
    () => financeConfig === "E-CONOMIC" && isEconomicProductGroupsEnabled,
    [financeConfig, isEconomicProductGroupsEnabled]
  );

  const {
    cargoTypeAllOptions,
    cargoQualityAllOptions,
    trailerQualityAllOptions,
    teamsOptions,
    cargoInvoiceStatusOptions,
  } = useShipmentFormSelectOptions();

  const [stopsCoords, setStopsCoords] = useState<
    { lon: number; lat: number }[]
  >(
    [
      ...initialData.pickupList.map((p) => ({
        lon: p.place?.coord?.lon!,
        lat: p.place?.coord?.lat!,
      })),
      ...initialData.dropoffList?.map((p) => ({
        lon: p.place?.coord?.lon!,
        lat: p.place?.coord?.lat!,
      })),
    ].filter((p) => p.lon && p.lat)
  );

  // The server already calculated the distance for the saved stops, so HERE
  // is only asked again once they change.
  const [savedDistance] = useState(() =>
    initialData.distanceKm != null
      ? {
          coordsKey: coordsToKey(stopsCoords),
          km: Number(initialData.distanceKm),
        }
      : null
  );

  useEffect(() => {
    if (stopsCoords.length < 2) {
      return;
    }
    if (savedDistance && coordsToKey(stopsCoords) === savedDistance.coordsKey) {
      setEstimatedDistance(savedDistance.km);
      return;
    }
    // A slower response for older stops must not overwrite a newer one.
    let stale = false;
    getEstimatedDistanceForCoords(stopsCoords)
      .then((res) => {
        if (!stale) {
          setEstimatedDistance(res.data.km);
        }
      })
      .catch(() => {
        // nothing to do, here maps error most likely
      });
    return () => {
      stale = true;
    };
  }, [stopsCoords, savedDistance]);

  const convertReduxStopDataToFormStopData = (stop: Stop) => {
    return {
      ...stop,
      date: DateTime.fromFormat(stop.date, "yyyy-MM-dd"),
      openingDate: stop.openingDate
        ? DateTime.fromFormat(stop.openingDate, "yyyy-MM-dd")
        : null,
    };
  };

  const liveExtraCo2Options = useMemo(
    () =>
      liveExtraCo2Types.map((type) => ({
        value: type.id,
        label: `${type.name} (${t(`extraCO2Types:type`, {
          context: type.unit,
        })})`,
      })),
    [liveExtraCo2Types, t]
  );

  // A deleted type can't be picked, but a line that already uses it still
  // shows it, so its emissions stay visible as they were saved.
  const extraCo2OptionsForLine = (extraCo2TypeId: string) => {
    const type = extraCo2Types.find((x) => x.id === extraCo2TypeId);
    if (!type || type.deletedAt === null) {
      return liveExtraCo2Options;
    }
    return [
      ...liveExtraCo2Options,
      {
        value: type.id,
        label: t("extraCO2Types:deletedTypeLabel", {
          name: type.name,
          unit: t(`extraCO2Types:type`, { context: type.unit }),
        }),
      },
    ];
  };

  const mapInitialDataFormValues = (
    initialData: CargoData,
    clientIdForTemplate?: string
  ): CreateShipmentData => ({
    ...initialData,
    products: initialData.products
      .map((pId) => products.find((p) => p.id === pId))
      .filter(isNotNullOrUndefined),
    driverCanRegisterTime: createNew
      ? driverShouldRegisterTime
      : initialData.driverCanRegisterTime,
    hideForDrivers: createNew
      ? hideCargoFromDriversDefault
      : initialData.hideForDrivers,
    driverCanAddDropoffs: createNew
      ? driverCanAddStopsDefault
      : initialData.driverCanAddDropoffs,
    driverCanMoveFromToUndispatched: createNew
      ? driverCanPickFromUndispatchedDefault
      : initialData.driverCanMoveFromToUndispatched,
    pickupList: initialData.pickupList.map(convertReduxStopDataToFormStopData),
    dropoffList: initialData.dropoffList.map(
      convertReduxStopDataToFormStopData
    ),
    // An option this version doesn't know is dropped.
    qualities: initialData.qualities
      .map((quality) => cargoQualityAllOptions.find((o) => o.id === quality))
      .filter(isNotNullOrUndefined),
    requirements: initialData.requirements
      .map((requirement) =>
        trailerQualityAllOptions.find((o) => o.id === requirement)
      )
      .filter(isNotNullOrUndefined),
    ...("ref" in initialData
      ? { ref: initialData.ref ?? null }
      : { ref: null }),
    customerContactId: initialData.customerContactId || null,
    INVOICE_REF_LOCKED: !!initialData.invoiceRef,
    clientId: clientIdForTemplate || initialData.clientId,
  });

  const formMethods = useForm<CreateShipmentData>({
    criteriaMode: "all",
    resolver: yupResolver(
      getValidationSchema(stopTimeRequired, clientRequiredOnCargos, hideLm),
      {
        abortEarly: false,
      }
    ),
    defaultValues: mapInitialDataFormValues(initialData, clientIdForTemplate),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, dirtyFields },
    setValue,
    reset,
    getValues,
    control,
    watch,
  } = formMethods;

  // DORA-441: the open cargo follows changes made elsewhere while it is open,
  // so its next save goes through instead of overwriting them.
  const revisionSyncEnabled = useFeature("check-cargo-revision-when-saving");
  // Cargo templates too: each is a cargo row with a revision of its own.
  const syncSource = openCargoSyncSource(entityType);
  const syncedCargoId =
    revisionSyncEnabled && !createNew && !deleted && syncSource ? id : null;
  const { mergeAfterOutdatedSave, catchUp } = useOpenCargoSync({
    cargoId: syncedCargoId,
    // Unused while syncedCargoId is null.
    source: syncSource ?? cargoSyncSource,
    formMethods,
    toFormValues: (data) => mapInitialDataFormValues(data, clientIdForTemplate),
    isSaving,
  });
  const remoteConflict = useSelector((state) =>
    syncSource ? syncSource.selectRemoteConflict(state) : false
  );

  // Only the stop counts, not watch("pickupList"): watching a list re-renders
  // the whole dialog on every keystroke in any of its stops' fields
  // (DISPATCHER-D5 / DORA-459).
  const pickupListLength = useWatch({
    control,
    name: "pickupList",
    compute: (list) => list?.length ?? 0,
  });
  const dropoffListLength = useWatch({
    control,
    name: "dropoffList",
    compute: (list) => list?.length ?? 0,
  });
  const selectedTeamIdWatch = watch("assignedTeamId");
  const clientIdWatch = watch("clientId");
  // Picking a different client invalidates the selected client cargo
  // template (it's scoped to the client it was loaded for) - this doesn't
  // fire right after loading a template since that also sets clientId to
  // the same value.
  useEffect(() => {
    if (selectedTemplate && clientIdWatch !== selectedTemplate.clientId) {
      dispatch(clearSelectedTemplate());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientIdWatch]);
  // Mark the selected customer as in focus (join its socket room) so live
  // delivery-address coordinate updates flow in while it stays selected.
  useFocusCustomer(clientIdWatch);
  const pricingAgreementsForSelectedClient = useSelector(
    selectPricingAgreementsForClient(clientIdWatch)
  );
  const {
    cargoQualitiesSelectableOptions,
    trailerQualitiesSelectableOptions,
    cargoTypeSelectableOptions,
  } = useShipmentFormSelectTeamRelatedOptions({
    selectedTeamId: selectedTeamIdWatch,
  });

  const toProductOption = useCallback(
    (p: (typeof products)[number]) => {
      const pricingAgreementForClient = pricingAgreementsForSelectedClient.find(
        (pa) => pa.productId === p.id
      );
      return {
        id: p.id,
        label: pricingAgreementForClient
          ? `${p.productNumber} ${pricingAgreementForClient.name}`
          : `${p.productNumber} ${p.name}`,
      };
    },
    [pricingAgreementsForSelectedClient]
  );

  const productsOptions = useMemo(
    () => products.map(toProductOption),
    [products, toProductOption]
  );

  const selectableProductsOptions = useMemo(
    () =>
      productsGroupsEnabled
        ? dispatcherVisibleProducts.map(toProductOption)
        : productsOptions,
    [
      productsGroupsEnabled,
      dispatcherVisibleProducts,
      toProductOption,
      productsOptions,
    ]
  );

  const pickupNumber = pickupListLength || 1;
  const dropoffNumber = dropoffListLength || 1;

  const isSingleStop = dropoffListLength === 0 && pickupListLength === 1;
  const extraCo2List = watch("extraCo2Elements");
  const { remove, append } = useFieldArray({
    name: "extraCo2Elements",
    control,
  });

  const onCargoTypeSelect = useCallback(() => {
    const cargoType = getValues("type");
    const needsTemp = cargoTypeNeedsTemperature(cargoType);
    const needsContainerNo = cargoType
      ? cargoTypeNeedsContainerNo(cargoType)
      : false;
    setShouldShowContainerNoInput(needsContainerNo);
    setShouldShowTemperatureInput(needsTemp);
    if (!needsTemp) {
      setValue("minTemperature", "");
      setValue("maxTemperature", "");
    } else {
      const minTemp = getValues("minTemperature");
      const maxTemp = getValues("maxTemperature");
      if (!minTemp) {
        setValue("minTemperature", "0");
      }
      if (!maxTemp) {
        setValue("maxTemperature", "0");
      }
    }
    if (!needsContainerNo) {
      setValue("containerNo", "");
    }
  }, [getValues, setValue]);

  useEffect(() => {
    dispatch(loadStopUnitTemplatesAndTeams());
    dispatch(loadProductGroups());
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      onCargoTypeSelect();
    }
  }, [id, onCargoTypeSelect, dispatch]);

  const contacts = useSelector(selectCustomerContacts(clientIdWatch || null));

  const qualitiesId = useMemo(() => nanoid(), []);

  const productsIds = useMemo(
    () => getValues("products").map((p) => p.id),
    [getValues]
  );

  // contains all the form specific logic in which modifying something leads to
  // another input value / field data being modified
  useShipmentFormRules(
    formMethods,
    setDropoffAccumulatedInputsDisabled,
    setCustomerContactId,
    contacts,
    qualitiesId,
    newStopUnitsEnabled
  );

  useCalculateEstimatedShipmentDistance(
    formMethods,
    stopsCoords,
    setStopsCoords,
    setEstimatedDistance
  );

  const { addLineForProduct, lineCountByProductId } =
    useCreateInvoiceLinesOnSelectedProducts(
      formMethods,
      productsIds,
      deliveryId || null,
      createNew
    );

  const onSwitchPickupDropoff = () => {
    const pickups = getValues("pickupList");
    const dropoffs = getValues("dropoffList");
    reset({
      ...getValues(),
      pickupList: dropoffs,
      dropoffList: pickups,
    });
  };

  const onCreateClick = () =>
    submit({
      type: "CREATE",
      // A selected template's lines are already loaded into the in-memory
      // draft and persisted via the new endpoint, so don't also ask the
      // server to copy them (that would duplicate).
      copyInvoiceLinesFromCargoId: null,
      copyFilesFromCargoId: selectedTemplate?.cargoId || null,
    })
      .then(() => {
        dispatch(clearSelectedTemplate());
      })
      .catch(() => {});

  const scrollToTop = () => {
    const topElement = document.getElementsByClassName(
      "shipment-dialog__wrapper"
    )[0];
    if (topElement) {
      topElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const onDuplicateClick = async ({
    copyInvoiceLinesFromCargoId,
    copyFilesFromCargoId,
    resetInvoiceLineQuantities,
  }: {
    copyInvoiceLinesFromCargoId: string | null;
    copyFilesFromCargoId: string | null;
    resetInvoiceLineQuantities?: boolean;
  }) => {
    setDuplicateInProgress(true);
    try {
      // A deleted original has nothing left to save: copy the form as it is.
      // A save that finds it deleted just now carries on the same way.
      const saved = deleted
        ? {}
        : await submit({
            type: "UPDATE",
            copyInvoiceLinesFromCargoId: null,
            copyFilesFromCargoId: null,
          });
      // The save can come back refused without throwing; don't copy a form
      // that wasn't saved.
      if (saved.error === ERR_CANNOT_DELETE_STOP_WITH_EVENTS) {
        setShouldShowConfirmUpdateCargoDeleteStops(true);
        return;
      }
      if (saved.error === ERR_OUTDATED_CARGO_REVISION) {
        setShouldShowOutdatedRevisionDialog(true);
        return;
      }
      const data = await submit({
        type: "DUPLICATE",
        copyInvoiceLinesFromCargoId,
        copyFilesFromCargoId,
        resetInvoiceLineQuantities,
      });
      if (data.id) {
        onClose({});
        navigate(
          { hash: `#cargo=${data.id}`, search: location.search },
          { replace: true }
        );
        setId(data.id);
      }
    } catch (err) {
    } finally {
      setDuplicateInProgress(false);
    }
  };

  const resetToInitialData = () => {
    if (!resetData.clientId) {
      setShouldShowClientSelect(false);
      setTimeout(() => {
        setShouldShowClientSelect(true);
      }, 10);
    }
    setCustomerContactId(resetData.customerContactId || null);
    if (!resetData.customerContactId) {
      setShouldShowContactSelect(false);
      setTimeout(() => {
        setShouldShowContactSelect(true);
      }, 10);
    }
    reset(mapInitialDataFormValues(resetData, clientIdForTemplate));
  };

  // The three "create and copy" split-button options that stay in create
  // mode afterward and reset the draft to a fresh copy of what was just
  // submitted (see cargo-dialog's submit.fulfilled CREATE_AND_MAKE_COPY
  // branch) — they only differ in what happens to the in-memory draft invoice
  // lines for that next copy, since the created cargo itself always carries
  // whatever was actually entered/submitted.
  const runCreateAndCopy = (afterSuccess?: () => void) => {
    setCreateCopyInProgress(true);
    submit({
      type: "CREATE_AND_MAKE_COPY",
      copyInvoiceLinesFromCargoId: selectedTemplate?.cargoId || null,
      copyFilesFromCargoId: selectedTemplate?.cargoId || null,
    })
      .then(() => {
        afterSuccess?.();
      })
      .catch(() => {})
      .then(() => {
        dispatch(clearSelectedTemplate());
      })
      // .then(() => setValue("ref", createCargoRef()))
      .finally(() => setCreateCopyInProgress(false));
  };

  const onCreateAndCopyOrderClick = () =>
    runCreateAndCopy(() => dispatch(draftLinesCleared()));

  const onCreateAndMakeCopyClick = () => runCreateAndCopy();

  const onCreateAndCopyWithInvoiceLinesResetQtyClick = () =>
    runCreateAndCopy(() => dispatch(draftLinesQuantitiesReset()));

  const onOpenCreateOnDriverRoutesClick = () => {
    buildCargoFormPayload({ type: "CREATE_AND_MAKE_COPY" })
      .then((data) => {
        setCreateOnDriverRoutesFormData(data);
        setCreateOnDriverRoutesDialogOpen(true);
      })
      .catch(() => {});
  };

  const onConfirmSaveWithDeletingStopsActivitiesClick = () => {
    setShouldShowConfirmUpdateCargoDeleteStops(false);
    onSaveClick({ deleteStopsWithEvents: true });
  };

  const onSaveClick = (options = { deleteStopsWithEvents: false }) =>
    submit({
      type: "UPDATE",
      deleteStopsWithEvents: options.deleteStopsWithEvents,
      copyInvoiceLinesFromCargoId: null,
      copyFilesFromCargoId: null,
    })
      .then((res: any) => {
        if (res.error === ERR_CANNOT_DELETE_STOP_WITH_EVENTS) {
          setShouldShowConfirmUpdateCargoDeleteStops(true);
          return;
        }
        if (res.error === ERR_OUTDATED_CARGO_REVISION) {
          setShouldShowOutdatedRevisionDialog(true);
          return;
        }
        // Stay open on the deleted banner, with the user's edits still there.
        if (res.error === ERR_CARGO_ALREADY_DELETED) {
          return;
        }
        dispatch(clearSelectedTemplate());
        onClose({
          cargoId: id || undefined,
        });
      })
      .catch((err) => {
        console.error(err);
      });

  // Validates the form and shapes its current values into a CargoData-ish
  // payload. Shared by submit() (which goes on to POST it) and the "copy to
  // driver's route(s)" flow (which instead hands it to
  // CreateCargoOnDriverRoutesDialog, since there's no cargo id yet to reuse
  // the existing copy-to-driver-routes endpoint).
  const buildCargoFormPayload = useCallback(
    (options: {
      type: "CREATE" | "UPDATE" | "DUPLICATE" | "CREATE_AND_MAKE_COPY";
      deleteStopsWithEvents?: boolean;
      keepAlive?: boolean;
    }): Promise<
      Omit<CargoData, "ref"> & {
        keepAlive?: boolean;
        deleteStopsWithEvents?: boolean;
      }
    > => {
      scrollToTop();
      return new Promise((resolve, reject) => {
        handleSubmit(
          async () => {
            const data: Omit<CargoData, "ref"> & {
              keepAlive?: boolean;
              deleteStopsWithEvents?: boolean;
            } = {
              ...getValues(),
              route_id: routeId,
              customerContactId: customerContactId || null,

              // adjustments for old format data
              pickupList: getValues("pickupList").map(mapFormStopToAPIFormat),
              dropoffList: (hideLm
                ? reconcileHiddenDropoffLoadmeters(
                    getValues("pickupList"),
                    getValues("dropoffList")
                  )
                : getValues("dropoffList")
              ).map(mapFormStopToAPIFormat),
              stopUnits: (() => {
                const rawStopUnits = getValues("stopUnits");
                return (rawStopUnits || []).map((su: any) => ({
                  id: su.id,
                  pickupId: su.pickupId,
                  dropoffId: su.dropoffId,
                  description: su.description,
                  weight: su.weight || null,
                  width: su.width || null,
                  length: su.length || null,
                  height: su.height || null,
                  volume: su.volume || null,
                  colli: su.colli || null,
                  quantity: su.quantity,
                  stopUnitTemplateId: su.stopUnitTemplateId,
                }));
              })(),
              cmrConfigs: (getValues("cmrConfigs") || []).map((c) => ({
                id: c.id,
                pickupId: c.pickupId,
                dropoffId: c.dropoffId,
              })),
              products: getValues("products").map((p) => p.id),

              keepAlive: options.keepAlive, // fix this nonsense
              deleteStopsWithEvents: options.deleteStopsWithEvents,
              qualities: getValues("qualities").map((q) => q.id),

              // not implemented yet
              requirements: getValues("requirements").map((q) => q.id),
              smartMatch: false,

              ...(options.type === "UPDATE" && {
                id: initialData.id,
                keepAlive: true,
              }),
              ...(options.type === "DUPLICATE" && {
                keepAlive: true,
                // The duplicate starts its own invoicing life, no matter the
                // original's status
                invoiceStatus: "OPEN" as const,
                // Only a cargo created from a template references it; a
                // duplicate is created from the original cargo, not the template
                clientCargoTemplateId: null,
              }),
              ...(options.type === "CREATE_AND_MAKE_COPY" && {
                keepAlive: true,
              }),
              ...(options.type === "CREATE" && {
                clientCargoTemplateId: selectedTemplate?.id || null,
              }),
            };
            resolve(data);
          },
          (errors) => {
            // yupResolver attaches the input's DOM element as `ref` on every
            // field error, which is circular and unreadable when logged.
            console.debug(
              "[DEBUG] Validation error:",
              JSON.stringify(
                errors,
                (key, value) => (key === "ref" ? undefined : value),
                2
              )
            );
            reject("VALIDATION_ERROR");
          }
        )();
      });
    },
    [
      customerContactId,
      getValues,
      handleSubmit,
      hideLm,
      routeId,
      initialData,
      selectedTemplate,
    ]
  );

  const submit = useCallback(
    async (options: {
      type: "CREATE" | "UPDATE" | "DUPLICATE" | "CREATE_AND_MAKE_COPY";
      copyInvoiceLinesFromCargoId: string | null;
      copyFilesFromCargoId: string | null;
      resetInvoiceLineQuantities?: boolean;
      deleteStopsWithEvents?: boolean;
      keepAlive?: boolean;
    }): Promise<{ id?: string; keepAlive?: boolean; error?: string }> => {
      // The form is read again on every send: a merge of someone else's
      // change (below) may have changed it since the first.
      const send = async (dropDeletedExtraCo2Types: boolean) => {
        const data = await buildCargoFormPayload(options);
        return onSubmit({
          ...data,
          submitType: options.type,
          cargoIdToCopyInvoiceLinesFrom: options.copyInvoiceLinesFromCargoId,
          cargoIdToCopyFilesFrom: options.copyFilesFromCargoId,
          resetInvoiceLineQuantities: options.resetInvoiceLineQuantities,
          dropDeletedExtraCo2Types,
        });
      };
      // DORA-441: an edit of a cargo or template the dialog keeps in sync
      // with changes made elsewhere.
      const save = async (dropDeletedExtraCo2Types: boolean) => {
        if (options.type !== "UPDATE" || !syncedCargoId) {
          return send(dropDeletedExtraCo2Types);
        }
        // The form clashes with someone else's change: saving it would
        // overwrite that change, so answer as the server would.
        if (remoteConflict) {
          return { error: ERR_OUTDATED_CARGO_REVISION };
        }
        const result = await send(dropDeletedExtraCo2Types);
        // Someone else's change landed before this tab heard about it. When
        // it doesn't clash with the user's edits, take it in and save again,
        // once.
        if (
          result?.error === ERR_OUTDATED_CARGO_REVISION &&
          (await mergeAfterOutdatedSave())
        ) {
          return send(dropDeletedExtraCo2Types);
        }
        return result;
      };
      const result = await save(false);
      // (the client template create resolves with nothing)
      if (result?.error !== ERR_DELETED_EXTRA_CO2_TYPES) {
        return result;
      }
      // Every save path comes through here (save, duplicate, create and
      // copy, ...), so the question is asked once for all of them. Declining
      // rejects like a failed validation does: nothing was saved.
      if (!(await askToDropDeletedExtraCo2Types())) {
        throw DELETED_EXTRA_CO2_TYPES_DECLINED;
      }
      return save(true);
    },
    [
      askToDropDeletedExtraCo2Types,
      buildCargoFormPayload,
      onSubmit,
      syncedCargoId,
      remoteConflict,
      mergeAfterOutdatedSave,
    ]
  );

  const [stopFutureNavigation, setStopFutureNavigation] = useState(false);

  const onSaveKeysPressed = useCallback(
    (e: KeyboardEvent) => {
      const isCtrlOrCmd = e.ctrlKey || e.metaKey;
      if (isCtrlOrCmd && e.key === "s") {
        e.preventDefault(); // Prevent the default browser save behavior
        if (deleted) {
          return;
        }
        submit({
          type: createNew ? "CREATE" : "UPDATE",
          keepAlive: true,
          copyInvoiceLinesFromCargoId: selectedTemplate?.cargoId || null,
          copyFilesFromCargoId: selectedTemplate?.cargoId || null,
        })
          .then((data: any) => {
            if (data.error === ERR_CANNOT_DELETE_STOP_WITH_EVENTS) {
              setShouldShowConfirmUpdateCargoDeleteStops(true);
              return;
            }
            if (data.error === ERR_OUTDATED_CARGO_REVISION) {
              setShouldShowOutdatedRevisionDialog(true);
              return;
            }
            if (data.error === ERR_CARGO_ALREADY_DELETED) {
              return;
            }

            dispatch(clearSelectedTemplate());

            const values = getValues();
            // What the form starts from now: what was just saved.
            const saved = {
              ...values,
              INVOICE_REF_LOCKED: !!values.invoiceRef,
            };
            reset(saved);
            const entityId = data.id || id;
            if (entityId) {
              let action;
              let postActionNavigationUrlPart;
              switch (entityType) {
                case CargoModalEntityType.CARGO:
                  action = loadCargo(entityId);
                  postActionNavigationUrlPart = "cargo";
                  break;
                case CargoModalEntityType.CLIENT_CARGO_TEMPLATE:
                  // Reload the template being edited. Not
                  // loadAndUseClientCargoTemplate: that one starts a new cargo
                  // from a template, and its payload.data is the whole template
                  // response - its id is the template record, not the cargo.
                  action = loadCargoTemplate(entityId);
                  postActionNavigationUrlPart = "clientCargoTemplate";
                  break;
                case CargoModalEntityType.SCHEDULE_CARGO_TEMPLATE:
                  action = loadScheduleCargoTemplate(entityId);
                  postActionNavigationUrlPart = "cargoTemplate";
                  break;
                default:
                  throw new Error(`Unknown entity type: ${entityType}`);
              }
              // DORA-441: the revision this save produced. A reload at
              // another one also carries a change someone else saved since.
              const savedRevision =
                syncSource && syncedCargoId
                  ? dispatch(loadedRevisionOf(syncSource))
                  : null;
              dispatch(action as any).then(
                (loadDataResponse: { payload: { data: CargoData } | null }) => {
                  // null: the cargo was deleted (from elsewhere) right after
                  // saving; loadCargo has already told the user.
                  if (!loadDataResponse.payload) return;
                  const cargoData: any = loadDataResponse.payload.data;
                  if (
                    entityType === CargoModalEntityType.CARGO ||
                    entityType === CargoModalEntityType.CLIENT_CARGO_TEMPLATE
                  ) {
                    setDeliveryId(cargoData.deliveryId);
                  }
                  setId(cargoData.id);
                  const savedLists = {
                    pickupList: saved.pickupList,
                    dropoffList: saved.dropoffList,
                    stopUnits: saved.stopUnits,
                    cmrConfigs: saved.cmrConfigs,
                  };
                  const adopted = adoptSavedStopIds(savedLists, cargoData);
                  // Where the reload put the dialog (each kind keeps the
                  // revision in its own place in the load's response).
                  const reloadedRevision = syncSource
                    ? dispatch(loadedRevisionOf(syncSource))
                    : null;
                  // A change from elsewhere merged in while the reload was on
                  // its way already moved the form on, ids and revision
                  // included: what it starts from is no longer what was saved.
                  // control._defaultValues, not formState.defaultValues: the
                  // latter is a snapshot from the last render, and the reload
                  // may well come back before the next one.
                  const mergedMeanwhile =
                    !!syncedCargoId &&
                    !sameValue(formMethods.control._defaultValues, saved);
                  if (mergedMeanwhile) {
                    // The reload, of this save, is older than that: take
                    // nothing from it, and stay on the merged revision it has
                    // just moved the dialog back from.
                    const mergedRevision =
                      formMethods.control._defaultValues.revision;
                    if (syncSource && mergedRevision) {
                      dispatch(syncSource.revisionAdopted(mergedRevision));
                    }
                  } else if (
                    syncSource &&
                    savedRevision &&
                    reloadedRevision !== savedRevision
                  ) {
                    // Someone else saved between this save and the reload.
                    // The reload is not this save, so the dialog stays on the
                    // revision it saved and takes their change in through the
                    // merge. Unless this save added rows that only get their
                    // ids from the reload: those are matched by position,
                    // which their change may have shifted, so there's no
                    // telling which ids are this save's.
                    if (!hasRowsAwaitingIds(savedLists, cargoData)) {
                      dispatch(syncSource.revisionAdopted(savedRevision));
                      catchUp();
                    } else {
                      dispatch(syncSource.remoteConflict());
                    }
                  } else {
                    if (cargoData.revision) {
                      setValue("revision", cargoData.revision);
                    }
                    // The ids are taken in as they are on screen, in case the
                    // user edited a list since saving.
                    const adoptedOnScreen = adoptSavedStopIds(
                      {
                        pickupList: getValues("pickupList"),
                        dropoffList: getValues("dropoffList"),
                        stopUnits: getValues("stopUnits") || [],
                        cmrConfigs: getValues("cmrConfigs") || [],
                      },
                      cargoData
                    );
                    // Per stop rather than the whole list, so the stops'
                    // field-array entries (and their inputs) aren't remounted.
                    adoptedOnScreen.pickupList.forEach((stop, i) => {
                      setValue(`pickupList.${i}.id`, stop.id);
                      setValue(`pickupList.${i}.provisoryId`, stop.provisoryId);
                    });
                    adoptedOnScreen.dropoffList.forEach((stop, i) => {
                      setValue(`dropoffList.${i}.id`, stop.id);
                      setValue(
                        `dropoffList.${i}.provisoryId`,
                        stop.provisoryId
                      );
                    });
                    setValue("stopUnits", adoptedOnScreen.stopUnits);
                    setValue("cmrConfigs", adoptedOnScreen.cmrConfigs);
                    // DORA-441: the revision and the ids taken in above are
                    // the server's, not edits of the user's. What the form
                    // started from (what was saved) takes them in too;
                    // otherwise the next merge of someone else's change sees
                    // them changed on both sides and calls it a clash. The
                    // values on screen, and what is marked unsaved, stay as
                    // they are.
                    reset(
                      {
                        ...saved,
                        ...(cargoData.revision && {
                          revision: cargoData.revision,
                        }),
                        ...adopted,
                      },
                      {
                        keepValues: true,
                        keepDirty: true,
                        keepErrors: true,
                        keepTouched: true,
                        keepIsValid: true,
                        keepIsSubmitted: true,
                        keepSubmitCount: true,
                      }
                    );
                  }
                  if (createNew) {
                    setCanBeDeleted(true);
                  }
                  if (!stopFutureNavigation) {
                    const currentParams = new URLSearchParams(
                      location.hash.substring(1)
                    );
                    currentParams.set(postActionNavigationUrlPart, entityId);
                    navigate(
                      {
                        hash: currentParams.toString(),
                        search: location.search,
                      },
                      { replace: true }
                    );
                  }
                }
              );
            }
          })
          .catch(() => {});
      }
    },
    [
      createNew,
      submit,
      navigate,
      location,
      dispatch,
      setDeliveryId,
      setId,
      id,
      setValue,
      entityType,
      getValues,
      reset,
      formMethods,
      stopFutureNavigation,
      deleted,
      catchUp,
      syncSource,
      syncedCargoId,
    ]
  );

  useEffect(() => {
    document.addEventListener("keydown", onSaveKeysPressed);
    return () => {
      document.removeEventListener("keydown", onSaveKeysPressed);
    };
  }, [onSaveKeysPressed]);

  // There are problems with use-forms yup resolver. See these issues:
  // https://github.com/react-hook-form/resolvers/issues/331
  // https://github.com/orgs/react-hook-form/discussions/6472
  const e = (errors as any)[""]?.types;
  const topLevelErrors =
    e?.lmMatch ||
    e?.colliMatch ||
    e?.unitsMatch ||
    e?.pickupTimesBeforeDropoffTimes ||
    e?.stopUnitsAssigned ||
    e?.clientRequired;

  const pickupsNumber = getValues("pickupList").length;
  const dropoffsNumber = getValues("dropoffList").length;

  const isDriversCanAddStopsCheckboxDisabled = useMemo(() => {
    return pickupsNumber > 1 && !manyToManyEnabled;
  }, [pickupsNumber, manyToManyEnabled]);

  const clientInputId = useMemo(() => nanoid(), []);
  const emailId = useMemo(() => nanoid(), []);
  const invoiceRefId = useMemo(() => nanoid(), []);
  const description2Id = useMemo(() => nanoid(), []);
  const shipmentRefId = useMemo(() => nanoid(), []);
  const contactId = useMemo(() => nanoid(), []);
  const phoneId = useMemo(() => nanoid(), []);
  const driverCanAddDropoffsId = useMemo(() => nanoid(), []);
  const driverShouldRegisterTimeId = useMemo(() => nanoid(), []);
  const hideCargoFromDriverId = useMemo(() => nanoid(), []);
  const teamId = useMemo(() => nanoid(), []);
  const trailerDemandsId = useMemo(() => nanoid(), []);
  const noteId = useMemo(() => nanoid(), []);
  const driverCanMoveFromToUndispatchedId = useMemo(() => nanoid(), []);

  const driverCanAddStopsChecked = watch("driverCanAddDropoffs");

  const modalTitle = useMemo(() => {
    switch (`${entityType}__${createNew}`) {
      case `${CargoModalEntityType.CARGO}__true`:
        return t("shipmentModal:titleNew");
      case `${CargoModalEntityType.CARGO}__false`:
        return t("shipmentModal:titleEdit");
      case `${CargoModalEntityType.SCHEDULE_CARGO_TEMPLATE}__true`:
        return t("shipmentModal:titleNewTemplate");
      case `${CargoModalEntityType.SCHEDULE_CARGO_TEMPLATE}__false`:
        return t("shipmentModal:titleEditTemplate");
      case `${CargoModalEntityType.CLIENT_CARGO_TEMPLATE}__true`:
        return t("shipmentModal:titleNewClientTemplate");
      case `${CargoModalEntityType.CLIENT_CARGO_TEMPLATE}__false`:
        return t("shipmentModal:titleEditClientTemplate");
      default:
        throw new Error(`Unknown combination: ${entityType}__${createNew}`);
    }
  }, [entityType, createNew, t]);

  const handleOnClose = () => {
    if (
      initialData.id &&
      entityType === CargoModalEntityType.CARGO &&
      Object.keys(dirtyFields).length > 0
    ) {
      setShouldShowExitWithoutSavingWarning(true);
      return;
    }
    close();
  };

  const close = () => {
    setStopFutureNavigation(true);
    onClose({
      formData: {
        ...getValues(),

        // adjustments for old format data
        pickupList: getValues("pickupList").map(mapFormStopToAPIFormat),
        dropoffList: getValues("dropoffList").map(mapFormStopToAPIFormat),

        // will be removed from top level
        minTemperature: "",
        maxTemperature: "",

        // not implemented yet
        // route_id: routeId, <-- TODO: this does not exist on CargoFormData
        smartMatch: false,

        // fix this nonsense
        qualities: getValues("qualities").map((q) => q.id),
        requirements: getValues("requirements").map((q) => q.id),
      } as any, // TODO: fix this if possible
      cargoId: initialData.id,
    });
  };

  const adrWatch = watch("adr");
  useEffect(() => {
    if (!adrWatch) {
      setValue("adrText", "");
    }
  }, [adrWatch, setValue]);

  // This should be used somehow with useForms instead (controlled component)
  const onClientContactChange = (data: Partial<ContactPersonData>) => {
    if (data.contactPersonId !== undefined) {
      setCustomerContactId(data.contactPersonId);
    }
    setValue("clientContact", data.name || "");
    if (data.phone !== undefined) {
      setValue("clientContactPhone", data.phone);
    }
    if (data.email !== undefined) {
      setValue("clientContactEmail", data.email);
    }
  };

  const onContactInputValueChange = (v: string) => {
    const contact = contacts?.find((c) => c.name === v);
    if (contact) {
      onClientContactChange({
        name: contact.name,
        contactPersonId: contact.id,
        phone: contact.phone || "",
        email: contact.email || "",
      });
    } else {
      onClientContactChange({
        name: v,
        contactPersonId: null,
      });
    }
  };

  const onAddExtraCo2Elements = () => {
    append({
      value: new Decimal(0),
      extraCo2TypeId: liveExtraCo2Types[0].id,
    });
  };

  const onRemoveExtraCo2Elements = (index: number) => {
    remove(index);
  };

  const [templateChanged, setTemplateChanged] = useState({});
  const onAfterTemplateSelectLoad = () => setTemplateChanged({});
  useEffect(() => {
    const resetData = {
      ...initialData,
      ...(clientIdForTemplate && { clientId: clientIdForTemplate }),
    };
    reset(mapInitialDataFormValues(resetData));
    if (initialData.deliveryId) {
      setDeliveryId(initialData.deliveryId);
    }
    // The reset() above already populates dropoffList; this deferred setValue
    // only seeds the two form-only flags onto the dropoff rows. It must be
    // deferred because a setValue on a field-array right after reset() doesn't
    // apply until react-hook-form re-registers the array on the next render.
    //
    // IMPORTANT: seed the flags onto the *current* dropoffList rather than
    // rebuilding from initialData.dropoffList. Rebuilding re-injected the
    // original dropoff (with its DB id) after the user had swapped it into the
    // pickup list, producing a pickup and dropoff that shared the same id.
    //
    // Set the flags row by row, not by replacing the whole array: a setValue
    // on "dropoffList" makes react-hook-form give every row a new field id,
    // and StopList keys rows by that id, so every dropoff remounted (and its
    // StopDocumentsList refetched, DORA-385).
    setTimeout(() => {
      const currentDropoffs = getValues("dropoffList") || [];
      currentDropoffs.forEach((_stop, i) => {
        setValue(`dropoffList.${i}.CMR_TAG_LOCKED`, false);
        setValue(`dropoffList.${i}.HAS_SORTING_DATE_BEEN_CHANGED`, false);
      });
    }, 300);
  }, [templateChanged]);

  return (
    <Dialog
      open
      {...(!liteVersion && { fullScreen: true })}
      {...(liteVersion && { maxWidth: "xl" })}
      onClose={handleOnClose}
    >
      {shouldShowExitWithoutSavingWarning && (
        <GenericPromptDialog
          title={t("shipmentModal:confirmExitWithoutSaving.title")}
          text={t("shipmentModal:confirmExitWithoutSaving.message")}
          onCancelClick={() => setShouldShowExitWithoutSavingWarning(false)}
          onContinueClick={close}
          cancelText={t("shipmentModal:confirmExitWithoutSaving.cancel")}
          continueText={t("shipmentModal:confirmExitWithoutSaving.continue")}
        />
      )}
      {copyToRoutesDialogOpen && id && copyToDriverRoutesEnabled && (
        <CopyCargoToDriverRoutesDialog
          cargoId={id}
          onClose={() => setCopyToRoutesDialogOpen(false)}
        />
      )}
      {createOnDriverRoutesDialogOpen &&
        createOnDriverRoutesFormData &&
        copyToDriverRoutesEnabled && (
          <CreateCargoOnDriverRoutesDialog
            cargoFormData={createOnDriverRoutesFormData}
            onClose={() => setCreateOnDriverRoutesDialogOpen(false)}
          />
        )}
      {shouldShowConfirmDeleteDialog && (
        <GenericPromptDialog
          title={t("shipmentModal:confirmShipmentDelete.title")}
          text={t("shipmentModal:confirmShipmentDelete.message")}
          onCancelClick={() => setShouldShowConfirmDeleteDialog(false)}
          continueButtonColor={"error"}
          continueText={t("components:buttonLabels.delete")}
          buttonsDisabled={deleteInProgress}
          onContinueClick={async () => {
            setDeleteInProgress(true);
            try {
              await onDelete();
            } finally {
              setDeleteInProgress(false);
              setShouldShowConfirmDeleteDialog(false);
            }
          }}
        />
      )}
      {shouldShowOutdatedRevisionDialog && (
        <GenericPromptDialog
          title={t("shipmentModal:outdatedRevision.title")}
          text={t("shipmentModal:outdatedRevision.message")}
          cancelText={t("shipmentModal:outdatedRevision.close")}
          continueText={t("shipmentModal:outdatedRevision.back")}
          onCloseClick={() => setShouldShowOutdatedRevisionDialog(false)}
          onCancelClick={() => {
            setShouldShowOutdatedRevisionDialog(false);
            onClose({});
          }}
          onContinueClick={() => {
            setShouldShowOutdatedRevisionDialog(false);
          }}
        />
      )}
      {dropDeletedExtraCo2TypesDialog}
      {shouldShowConfirmUpdateCargoDeleteStops && (
        <GenericPromptDialog
          title={t("shipmentModal:confirmSaveShipmentWithDeletingStops.title")}
          text={t("shipmentModal:confirmSaveShipmentWithDeletingStops.message")}
          onCancelClick={() =>
            setShouldShowConfirmUpdateCargoDeleteStops(false)
          }
          onContinueClick={onConfirmSaveWithDeletingStopsActivitiesClick}
          continueButtonColor="error"
        />
      )}
      <FormProvider {...formMethods}>
        <div className="shipment-dialog__wrapper">
          <div className="shipment-dialog__sticky-header">
            <div className="shipment-dialog__top-bar">
              <div className="shipment-dialog-top-bar__left">
                <div className="shipment-dialog__title">{modalTitle}</div>
              </div>
              <div className="shipment-dialog-top-bar__right">
                {createNew ? (
                  <>
                    <DoraButton
                      variant={"ghost"}
                      onClick={resetToInitialData}
                      disabled={isSaving}
                    >
                      {t("components:buttonLabels.clear")}
                    </DoraButton>
                    {entityType === CargoModalEntityType.CARGO && (
                      <CreateCargoCopyDropdown
                        disabled={isSaving}
                        createCopyInProgress={createCopyInProgress}
                        defaultOption={defaultCreateCopyOption}
                        showCopyToDriverRoutes={copyToDriverRoutesEnabled}
                        onCopyOrder={onCreateAndCopyOrderClick}
                        onCopyWithInvoiceLines={onCreateAndMakeCopyClick}
                        onCopyWithInvoiceLinesResetQty={
                          onCreateAndCopyWithInvoiceLinesResetQtyClick
                        }
                        onCopyToDriverRoutes={onOpenCreateOnDriverRoutesClick}
                      />
                    )}
                    <DoraButton
                      variant="primary"
                      className="shipment-dialog-top-bar__back-button"
                      disabled={isSaving}
                      onClick={handleOnClose}
                    >
                      {t("components:buttonLabels.cancel")}
                    </DoraButton>
                    <DoraButton
                      disabled={isSaving}
                      variant="primary-filled"
                      onClick={onCreateClick}
                    >
                      {t("components:buttonLabels.create")}
                    </DoraButton>
                  </>
                ) : (
                  <>
                    <DoraButton
                      title={t("shipmentModal:cannotDeleteInvoiced")}
                      disabled={isSaving || !canBeDeleted || deleted}
                      variant={"error"}
                      onClick={() => setShouldShowConfirmDeleteDialog(true)}
                    >
                      {t("shipmentModal:delete")}
                    </DoraButton>
                    {entityType === CargoModalEntityType.CARGO &&
                      !liteVersion && (
                        <DuplicateCargoDropdown
                          duplicateInProgress={duplicateInProgress}
                          disabled={isSaving}
                          // The other options copy from the saved original,
                          // which is gone.
                          onlyCopyOrder={deleted}
                          defaultOption={defaultCopyOption}
                          showCopyToDriverRoutes={copyToDriverRoutesEnabled}
                          onCopyOrder={() =>
                            onDuplicateClick({
                              copyInvoiceLinesFromCargoId: null,
                              copyFilesFromCargoId: null,
                            })
                          }
                          onCopyWithInvoiceLines={() =>
                            onDuplicateClick({
                              copyInvoiceLinesFromCargoId: id,
                              copyFilesFromCargoId: null,
                            })
                          }
                          onCopyWithInvoiceLinesResetQty={() =>
                            onDuplicateClick({
                              copyInvoiceLinesFromCargoId: id,
                              copyFilesFromCargoId: null,
                              resetInvoiceLineQuantities: true,
                            })
                          }
                          onCopyToDriverRoutes={() =>
                            setCopyToRoutesDialogOpen(true)
                          }
                        />
                      )}
                    <DoraButton
                      disabled={isSaving || deleted}
                      variant={"ghost"}
                      onClick={resetToInitialData}
                    >
                      {t("shipmentModal:undoChanges")}
                    </DoraButton>
                    <DoraButton
                      variant="primary"
                      className="shipment-dialog-top-bar__back-button"
                      disabled={isSaving}
                      onClick={handleOnClose}
                    >
                      {t("components:buttonLabels.cancel")}
                    </DoraButton>
                    <DoraButton
                      disabled={isSaving || deleted}
                      variant={"primary-filled"}
                      onClick={() => onSaveClick()}
                    >
                      {t("components:buttonLabels.save")}
                    </DoraButton>
                  </>
                )}
              </div>
            </div>
            <div className="shipment-dialog__second-row">
              {liteVersion || entityType !== CargoModalEntityType.CARGO ? (
                <div></div>
              ) : (
                <ScrollNavigationTabs />
              )}
              <div className="shipment-dialog__shipment-stats">
                <RouteRoadToll cargoId={id} />
                {!liteVersion && (
                  <div className="shipment-dialog__shipment-stat">
                    <div>{t("shipmentModal:inputs.routeRefLabel")}</div>
                    <div>{routeRef || "-"}</div>
                  </div>
                )}
                {entityType === CargoModalEntityType.CARGO && id && (
                  <WeightEventsErrorBoundary>
                    <WeightEventsTotalWeightAndTimeSpent cargoId={id} />
                  </WeightEventsErrorBoundary>
                )}
                <div className="shipment-dialog__shipment-stat">
                  <div>{t("shipmentModal:estDistance")}</div>
                  <div>
                    {estimatedDistance
                      ? `${estimatedDistance.toString().replace(".", ",")} km`
                      : "-"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {deleted && <DeletedCargoBanner cargoId={id} />}
          {syncedCargoId && remoteConflict && <RemoteChangesConflictBanner />}
          {topLevelErrors && (
            <div className="shipment-dialog__errors-section">
              <FontAwesomeIcon
                className="shipment-dialog-errors-section__icon"
                icon={faExclamationTriangle}
              />
              <div>
                <div className="shipment-dialog-errors-section__title">
                  {t("shipmentModal:errors.headerGenericFail")}
                </div>
                <ul>
                  {e.lmMatch && <li>{t("shipmentModal:errors.lmMatch")}</li>}
                  {e.colliMatch && (
                    <li>{t("shipmentModal:errors.colliMatch")}</li>
                  )}
                  {e.unitsMatch && (
                    <li>{t("shipmentModal:errors.unitsMatch")}</li>
                  )}
                  {e.pickupTimesBeforeDropoffTimes && (
                    <li>
                      {t("shipmentModal:errors.timesPickupsBeforeDropoffs")}
                    </li>
                  )}
                  {e.stopUnitsAssigned && (
                    <li>{t("shipmentModal:errors.stopUnitsAssigned")}</li>
                  )}
                  {e.clientRequired && (
                    <li>{t("shipmentModal:errors.clientRequired")}</li>
                  )}
                </ul>
              </div>
            </div>
          )}
          <div className="shipment-dialog__content">
            <div className="shipment-dialog__content-left">
              <div
                id="shipment-dialog-section__shipment"
                className="shipment-dialog__content-card"
              >
                {/* Top: main fields (left) + driver-settings box (right) */}
                <div
                  style={{
                    display: "flex",
                    gap: 16,
                    alignItems: "flex-start",
                    flexWrap: "wrap",
                    marginTop: "1rem",
                  }}
                >
                  <div style={{ flex: "1 1 320px", minWidth: 0 }}>
                    {/* Identity + content: type, label, varer, udstyr on one row */}
                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <div className="shipment-cargo-type-dropdowns">
                        <div>
                          <UFDoraSelect
                            autofocus
                            size="small"
                            maxWidth={170}
                            name={"type"}
                            control={control}
                            placeholder={t(
                              "shipmentModal:inputs.typePlaceholder"
                            )}
                            options={cargoTypeAllOptions}
                            selectableOptions={cargoTypeSelectableOptions}
                            onChange={onCargoTypeSelect}
                            error={!!errors.type}
                          />
                          {errors.type && (
                            <div className="shipment-cargo-form__error">
                              {t(
                                `shipmentModal:errors.${errors.type.message}` as any
                              )}
                            </div>
                          )}
                        </div>
                        {shouldShowContainerNoInput && (
                          <UFDoraTextInput
                            register={register("containerNo")}
                            placeholder={t(
                              "shipmentModal:inputs.containerNoPlaceholder"
                            )}
                          />
                        )}
                        {shouldShowTemperatureInput && (
                          <>
                            <UFDoraNumberInput
                              register={register("minTemperature")}
                              className={
                                "shipment-cargo-form__temperature-input"
                              }
                              suffix={"°C"}
                              placeholder={t(
                                "shipmentModal:inputs.minTempPlaceholder"
                              )}
                              error={!!errors.minTemperature}
                            />
                            <UFDoraNumberInput
                              register={register("maxTemperature")}
                              className={
                                "shipment-cargo-form__temperature-input"
                              }
                              suffix={"°C"}
                              placeholder={t(
                                "shipmentModal:inputs.maxTempPlaceholder"
                              )}
                              error={!!errors.maxTemperature}
                            />
                          </>
                        )}
                      </div>
                      {!liteVersion && (
                        <div style={{ width: 170 }}>
                          <CargoTagSelect
                            className="shipment-cargo-tag-dropdown"
                            name={"cargoTagId"}
                            control={control}
                            valueForInputColor={watch("cargoTagId")}
                          />
                        </div>
                      )}
                      {!liteVersion && (
                        <div style={{ width: 170 }}>
                          <ProductsChipSelect
                            options={productsOptions}
                            selectableOptions={selectableProductsOptions}
                            placeholder={t("shipmentModal:inputs.products")}
                            onAddLine={addLineForProduct}
                            lineCountByProductId={lineCountByProductId}
                          />
                        </div>
                      )}
                      {!liteVersion &&
                        equipmentEnabled &&
                        entityType === CargoModalEntityType.CARGO && (
                          <div style={{ minWidth: 170, maxWidth: "100%" }}>
                            <EquipmentSelect cargoId={id} />
                          </div>
                        )}
                    </div>
                    {/* Beskrivelse: dynamic-width box below the field row, fills to
                    the driver-app box on the right on all screen sizes */}
                    <div style={{ marginTop: 12, width: "100%" }}>
                      {serverAutocompleteEnabled ? (
                        <UFDoraMultilineTextAutocomplete
                          name="description"
                          control={control}
                          className="shipment-cargo-description"
                          placeholder={t(
                            "shipmentModal:inputs.shipmentDescription"
                          )}
                        />
                      ) : (
                        <UFDoraTextInput
                          register={register("description")}
                          className="shipment-cargo-description"
                          placeholder={t(
                            "shipmentModal:inputs.shipmentDescription"
                          )}
                          autoResize
                        />
                      )}
                    </div>
                  </div>
                  {/* Driver settings: vertical box on the right */}
                  {!liteVersion && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 10,
                        alignItems: "flex-start",
                        marginLeft: "auto",
                        padding: "10px 14px",
                        background: "var(--gray-50, #f7f8fa)",
                        border: "1px solid rgba(0, 0, 0, 0.06)",
                        borderRadius: 6,
                      }}
                    >
                      <span
                        style={{
                          fontSize: 13,
                          fontWeight: 500,
                          color: "var(--gray-600)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {t("shipmentModal:inputs.driverSettings", {
                          defaultValue: "Chaufførapp",
                        })}
                      </span>
                      {driverCreateDropdownsCheckboxEnabled && (
                        <div className="flex gap-2 items-center">
                          <UFDoraCheckbox
                            id={driverCanAddDropoffsId}
                            register={register("driverCanAddDropoffs")}
                            disabled={isDriversCanAddStopsCheckboxDisabled}
                          />
                          <label
                            className="shipment-dialog-input-list__label"
                            htmlFor={driverCanAddDropoffsId}
                            style={{ fontSize: 14 }}
                          >
                            {t(
                              "shipmentModal:inputs.driverCanAddDropoffsLabel"
                            )}
                          </label>
                        </div>
                      )}
                      <div className="flex gap-2 items-center">
                        <UFDoraCheckbox
                          id={driverCanMoveFromToUndispatchedId}
                          register={register("driverCanMoveFromToUndispatched")}
                        />
                        <label
                          className="shipment-dialog-input-list__label"
                          htmlFor={driverCanMoveFromToUndispatchedId}
                          style={{ fontSize: 14 }}
                        >
                          {t(
                            "shipmentModal:inputs.driverCanMoveFromToUndispatched"
                          )}
                        </label>
                        <Tooltip
                          arrow
                          title={t(
                            "shipmentModal:inputs.driverCanMoveFromToUndispatchedHint",
                            {
                              defaultValue:
                                "Chaufføren kan tage ordren fra pluklisten og lægge den tilbage igen.",
                            }
                          )}
                        >
                          <InfoOutlinedIcon
                            style={{
                              fontSize: 15,
                              color: "var(--gray-400)",
                              cursor: "help",
                            }}
                          />
                        </Tooltip>
                      </div>
                      {driverRegisterTimeEnabled && (
                        <div className="flex gap-2 items-center">
                          <UFDoraCheckbox
                            id={driverShouldRegisterTimeId}
                            register={register("driverCanRegisterTime")}
                            disabled={isDriversCanAddStopsCheckboxDisabled}
                          />
                          <label
                            className="shipment-dialog-input-list__label"
                            htmlFor={driverShouldRegisterTimeId}
                            style={{ fontSize: 14 }}
                          >
                            {t("shipmentModal:inputs.driverShouldRegisterTime")}
                          </label>
                        </div>
                      )}
                      <div className="flex gap-2 items-center">
                        <UFDoraCheckbox
                          id={hideCargoFromDriverId}
                          register={register("hideForDrivers")}
                        />
                        <label
                          className="shipment-dialog-input-list__label"
                          htmlFor={hideCargoFromDriverId}
                          style={{ fontSize: 14 }}
                        >
                          {t("shipmentModal:inputs.hideFromDrivers")}
                        </label>
                        <Tooltip
                          arrow
                          title={t("shipmentModal:inputs.hideFromDriversHint", {
                            defaultValue:
                              "Ordren vises ikke på chaufførappen, når fluebenet er sat.",
                          })}
                        >
                          <InfoOutlinedIcon
                            style={{
                              fontSize: 15,
                              color: "var(--gray-400)",
                              cursor: "help",
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  )}
                </div>
                <div className="shipment-cargo-forms-section">
                  <div className="shipment-cargo-forms-section__column">
                    <StopList
                      isPickup
                      errors={errors}
                      addButtonDisabled={
                        (dropoffsNumber > 1 && !manyToManyEnabled) ||
                        driverCanAddStopsChecked
                      }
                      isSingleStop={isSingleStop}
                      relativeFromPath="pickupList"
                      createNew={createNew}
                      stopsMayReferenceStaleData={initialDataFromCache}
                    />
                  </div>
                  <div>
                    {pickupNumber === 1 && dropoffsNumber === 1 && (
                      <DoraButton
                        variant={"ghost"}
                        onClick={onSwitchPickupDropoff}
                        style={{ padding: "5px" }}
                      >
                        <ImportExportIcon
                          style={{
                            transform: "rotate(90deg)",
                          }}
                        />
                      </DoraButton>
                    )}
                  </div>
                  <div className="shipment-cargo-forms-section__column">
                    <StopList
                      errors={errors}
                      disableAccumulatedInputs={
                        dropoffAccumulatedInputsDisabled
                      }
                      stopsLengthChanged={() =>
                        setDropoffAccumulatedInputsDisabled(
                          dropoffsNumber === 1
                        )
                      }
                      addButtonDisabled={
                        pickupsNumber > 1 &&
                        dropoffsNumber === 1 &&
                        !manyToManyEnabled
                      }
                      relativeFromPath="dropoffList"
                      createNew={createNew}
                      stopsMayReferenceStaleData={initialDataFromCache}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="shipment-dialog__content-right">
              <div className="shipment-dialog__content-card">
                <h3 className="shipment-dialog__content-card-title">
                  <div className="whitespace-nowrap">
                    {t("shipmentModal:clientInfoTitle")}
                  </div>
                  {!liteVersion && (
                    <div>
                      <UFDoraSelect
                        name={"invoiceStatus"}
                        maxWidth={170}
                        control={control}
                        disabled={invoiceStatusLocked}
                        placeholder={t(
                          "shipmentModal:inputs.invoiceStatusLabel"
                        )}
                        options={cargoInvoiceStatusOptions}
                      />
                    </div>
                  )}
                </h3>
                <div
                  style={{ paddingBottom: 42 }}
                  className="shipment-dialog__content-card-right-input-list"
                >
                  <div className="shipment-dialog-input-list__row">
                    <div className="flex items-center justify-between">
                      <label
                        className="shipment-dialog-input-list__label"
                        htmlFor={clientInputId}
                      >
                        {t("shipmentModal:inputs.clientLabel")}
                      </label>
                    </div>
                    {shouldShowClientSelect && (
                      <>
                        <div className="flex items-center">
                          <div className="flex-grow">
                            <ClientSelect
                              id={clientInputId}
                              placeholder={t(
                                "shipmentModal:inputs.clientLabel"
                              )}
                              refreshButtonLabel={t(
                                "shipmentModal:inputs.clientRefreshButtonLabel"
                              )}
                              name={"clientId"}
                              control={control}
                              clients={clients}
                              disabled={!!clientIdForTemplate}
                            />
                          </div>
                          <AddClientButtonAndModal />
                        </div>
                        {shareCargoEnabled &&
                          entityType === CargoModalEntityType.CARGO &&
                          id &&
                          !liteVersion && (
                            <SharedFromOrg
                              cargoId={id}
                              clientId={clientIdWatch}
                            />
                          )}
                      </>
                    )}
                  </div>
                  <SelectedClientDetails selectedClientId={clientIdWatch} />
                  {clientIdWatch && !liteVersion && !clientIdForTemplate && (
                    <div className="shipment-dialog-input-list__row">
                      <div className="flex justify-between items-center mb-3">
                        <label
                          className="shipment-dialog-input-list__label"
                          htmlFor={clientInputId}
                        >
                          {t("orderTemplates:orderTemplates")}
                        </label>
                        <ManageClientCargoTemplates />
                      </div>
                      {createNew && (
                        <ClientCargoTemplateSelect
                          clientId={clientIdWatch}
                          teamId={selectedTeamIdWatch}
                          onAfterSelectLoad={onAfterTemplateSelectLoad}
                        />
                      )}
                      <ClientCargoTemplateButtonsAndModal
                        cargoId={id || null}
                        createNewContext={createNew}
                        clientId={clientIdWatch}
                        teamId={selectedTeamIdWatch}
                        getShipmentFormData={getValues}
                        validateCargoData={handleSubmit}
                      />
                    </div>
                  )}
                  <div className="shipment-dialog-input-list__row">
                    <label
                      className="shipment-dialog-input-list__label"
                      htmlFor={invoiceRefId}
                    >
                      {t("shipmentModal:inputs.invoiceRefLabel")}
                    </label>
                    {serverAutocompleteEnabled ? (
                      <UFDoraMultilineTextAutocomplete
                        id={invoiceRefId}
                        name={"invoiceRef"}
                        control={control}
                        placeholder={t("shipmentModal:inputs.invoiceRefLabel")}
                      />
                    ) : (
                      <UFDoraTextInput
                        id={invoiceRefId}
                        register={register("invoiceRef")}
                        placeholder={t("shipmentModal:inputs.invoiceRefLabel")}
                        autoResize
                      />
                    )}
                  </div>
                  <div className="shipment-dialog-input-list__row">
                    <label
                      className="shipment-dialog-input-list__label"
                      htmlFor={description2Id}
                    >
                      {t("shipmentModal:inputs.description2Label")}
                    </label>
                    {serverAutocompleteEnabled ? (
                      <UFDoraMultilineTextAutocomplete
                        id={description2Id}
                        name={"description2"}
                        control={control}
                        placeholder={t(
                          "shipmentModal:inputs.description2Label"
                        )}
                      />
                    ) : (
                      <UFDoraTextInput
                        id={description2Id}
                        register={register("description2")}
                        placeholder={t(
                          "shipmentModal:inputs.description2Label"
                        )}
                        autoResize
                      />
                    )}
                  </div>
                  {id &&
                    entityType !==
                      CargoModalEntityType.SCHEDULE_CARGO_TEMPLATE && (
                      <div className="shipment-dialog-input-list__row">
                        <label
                          className="shipment-dialog-input-list__label"
                          htmlFor={shipmentRefId}
                        >
                          {t("shipmentModal:inputs.shipmentRefLabel")}
                        </label>
                        <UFDoraTextInput
                          id={shipmentRefId}
                          register={register("ref")}
                          placeholder={t(
                            "shipmentModal:inputs.shipmentRefLabel"
                          )}
                          disabled
                        />
                      </div>
                    )}
                  {!liteVersion && (
                    <>
                      <div className="shipment-dialog-input-list__row">
                        <label
                          className="shipment-dialog-input-list__label"
                          htmlFor={contactId}
                        >
                          {t("shipmentModal:inputs.contactLabel")}
                        </label>
                        {shouldShowContactSelect && (
                          <ClientContactSelect
                            id={contactId}
                            options={
                              contacts
                                ? contacts.map((c) => ({
                                    label: c.name,
                                    value: c.id,
                                  }))
                                : []
                            }
                            customerContactId={customerContactId}
                            onInputChange={onContactInputValueChange}
                            placeholder={t(
                              "shipmentModal:inputs.contactPlaceholder"
                            )}
                          />
                        )}
                      </div>
                      <div className="shipment-dialog-input-list__row">
                        <div className="flex justify-between items-center">
                          <label
                            className="shipment-dialog-input-list__label"
                            htmlFor={emailId}
                          >
                            {t("shipmentModal:inputs.emailLabel")}
                          </label>
                        </div>
                        <UFDoraTextInput
                          id={emailId}
                          register={register("clientContactEmail")}
                          placeholder={t(
                            "shipmentModal:inputs.emailPlaceholder"
                          )}
                        />
                      </div>
                      <div className="shipment-dialog-input-list__row">
                        <label
                          className="shipment-dialog-input-list__label"
                          htmlFor={phoneId}
                        >
                          {t("shipmentModal:inputs.phoneLabel")}
                        </label>
                        <UFDoraTextInput
                          id={phoneId}
                          register={register("clientContactPhone")}
                          placeholder={t(
                            "shipmentModal:inputs.phonePlaceholder"
                          )}
                        />
                      </div>
                      <div className="shipment-dialog-input-list__row">
                        <label
                          className="shipment-dialog-input-list__label"
                          htmlFor={noteId}
                        >
                          {t("shipmentModal:inputs.noteLabel")}
                        </label>
                        {serverAutocompleteEnabled ? (
                          <UFDoraMultilineTextAutocomplete
                            name={"note"}
                            control={control}
                            id={noteId}
                            placeholder={t(
                              "shipmentModal:inputs.notePlaceholder"
                            )}
                          />
                        ) : (
                          <UFDoraTextArea
                            id={noteId}
                            register={register("note")}
                            placeholder={t(
                              "shipmentModal:inputs.notePlaceholder"
                            )}
                            autoResize
                          />
                        )}
                      </div>
                      {entityType === CargoModalEntityType.CARGO && id && (
                        <div className="shipment-dialog-input-list__row">
                          <ShipmentDialogClientInfoMailLinks
                            truckNumber={truckNumber}
                            trailerNumber={trailerNumber}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              {shareCargoEnabled &&
                id &&
                entityType === CargoModalEntityType.CARGO &&
                !liteVersion && <ContractorInfoSection cargoId={id} />}
              <div className="shipment-dialog__content-card">
                <h3 className="shipment-dialog__content-card-title">
                  {t("shipmentModal:aboutShipmentTitle")}
                </h3>
                <div
                  style={{ paddingBottom: 16 }}
                  className="shipment-dialog__content-card-right-input-list"
                >
                  {!liteVersion && (
                    <>
                      <div className="shipment-dialog-input-list__row">
                        <label className="shipment-dialog-input-list__label">
                          {t("shipmentModal:inputs.adrLabel")}
                        </label>
                        <div className="flex gap-2 items-center">
                          <UFDoraCheckbox register={register("adr")} />
                          <div className="flex-grow">
                            <UFDoraTextInput
                              placeholder={t(
                                "shipmentModal:inputs.adrPlaceholder"
                              )}
                              disabled={!adrWatch}
                              register={register("adrText")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="shipment-dialog-input-list__row">
                        <label
                          className="shipment-dialog-input-list__label"
                          htmlFor={teamId}
                        >
                          {t("shipmentModal:inputs.assignedTeamLabel")}
                          <span aria-hidden>*</span>
                        </label>
                        <UFDoraSelect
                          id={teamId}
                          name={"assignedTeamId"}
                          control={control}
                          fullWidth
                          placeholder={t(
                            "shipmentModal:inputs.assignedTeamLabel"
                          )}
                          options={teamsOptions}
                          icon={faUsers}
                        />
                      </div>
                      <div className="shipment-dialog-input-list__row">
                        <label
                          className="shipment-dialog-input-list__label"
                          htmlFor={qualitiesId}
                        >
                          {t("shipmentModal:inputs.qualitiesLabel")}
                        </label>
                        <UFDoraSelectMultiple
                          id={qualitiesId}
                          placeholder={t(
                            "shipmentModal:inputs.qualitiesPlaceholder"
                          )}
                          control={control}
                          name={"qualities"}
                          options={cargoQualityAllOptions}
                          selectableOptions={cargoQualitiesSelectableOptions}
                        />
                      </div>
                      <div className="shipment-dialog-input-list__row">
                        <label
                          className="shipment-dialog-input-list__label"
                          htmlFor={trailerDemandsId}
                        >
                          {t("shipmentModal:inputs.demandsLabel")}
                        </label>
                        <UFDoraSelectMultiple
                          id={trailerDemandsId}
                          placeholder={t(
                            "shipmentModal:inputs.demandsPlaceholder"
                          )}
                          control={control}
                          name={"requirements"}
                          options={trailerQualityAllOptions}
                          selectableOptions={trailerQualitiesSelectableOptions}
                        />
                      </div>
                    </>
                  )}
                  {!liteVersion && (
                    <>
                      <div className="">
                        <label className="shipment-dialog-input-list__label">
                          {t("shipmentModal:inputs.extraCo2Label")}
                        </label>
                        <div className="">
                          {extraCo2List?.length > 0 &&
                            extraCo2List.map((line, index) => {
                              return (
                                <div
                                  key={index}
                                  className="grid grid-cols-12 my-2"
                                >
                                  <div className="col-span-3">
                                    <UFDoraNumberInput
                                      register={register(
                                        `extraCo2Elements.${index}.value`,
                                        {
                                          setValueAs: (v) => new Decimal(v),
                                        }
                                      )}
                                    />
                                  </div>
                                  <div className="col-span-1 flex items-center justify-center">
                                    <FontAwesomeIcon
                                      className="shipment-dialog-input-list__times"
                                      icon={faTimes}
                                    />
                                  </div>
                                  <div className="col-span-6">
                                    <UFDoraSelect
                                      name={`extraCo2Elements.${index}.extraCo2TypeId`}
                                      control={control}
                                      fullWidth
                                      options={extraCo2OptionsForLine(
                                        line.extraCo2TypeId
                                      )}
                                      className="w-full"
                                    />
                                  </div>
                                  <div className="col-span-2 flex">
                                    <DoraButton
                                      onClick={() =>
                                        onRemoveExtraCo2Elements(index)
                                      }
                                      variant="ghost"
                                      className="w-full"
                                    >
                                      <FontAwesomeIcon icon={faTrashAlt} />
                                    </DoraButton>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                      <DoraButton
                        variant={"ghost"}
                        onClick={onAddExtraCo2Elements}
                        disabled={liveExtraCo2Types.length === 0}
                        className="text-left"
                      >
                        <FontAwesomeIcon
                          icon={faPlus}
                          style={{ marginRight: 8 }}
                        />
                        {t("shipmentModal:inputs.addCo2Elements")}
                      </DoraButton>
                    </>
                  )}
                </div>
              </div>
              {(entityType === CargoModalEntityType.CARGO ||
                entityType === CargoModalEntityType.CLIENT_CARGO_TEMPLATE ||
                entityType ===
                  CargoModalEntityType.SCHEDULE_CARGO_TEMPLATE) && (
                <div className="shipment-dialog__content-card">
                  <div className="shipment-dialog__documents-card-wrapper">
                    <DocumentsCard
                      cargoId={
                        createNew && selectedTemplate
                          ? selectedTemplate.cargoId
                          : id
                      }
                      createNew={createNew}
                      previewMode={!!selectedTemplate}
                      pickupNumber={pickupNumber}
                      dropoffNumber={dropoffNumber}
                    />
                  </div>
                </div>
              )}
            </div>
            {!liteVersion && (
              <>
                <div className="shipment-dialog__content-left">
                  <div
                    id="shipment-dialog-section__finances"
                    className="shipment-dialog__content-card"
                  >
                    <h2 className="shipment-dialog__finances--title">
                      {t("shipmentModal:tabs.finances")}
                    </h2>
                    {(!createNew && deliveryId && id) ||
                    selectedTemplate ||
                    createNew ||
                    deliveryId ? (
                      <CreateEditShipmentFinancesAndDrivingReportCard
                        cargoId={id!}
                        // Only use the in-memory draft when actually creating.
                        createNew={createNew}
                        // TODO: add this property to the editCreateShipment interface, was impossible to do properly
                        cargoIsSplit={true}
                        deliveryId={deliveryId!}
                        clientId={clientIdWatch}
                        clientContact={customerContactId}
                        onInvoiceSent={() => {
                          setCanBeDeleted(false);
                          setValue("invoiceStatus", "INVOICED");
                          setInvoiceStatusLocked(true);
                        }}
                        disableSending={
                          entityType !== CargoModalEntityType.CARGO
                        }
                      />
                    ) : (
                      <div className="shipment-dialog__content-card-placeholder-text">
                        {t("shipmentModal:cards.finances.availableLater")}
                      </div>
                    )}
                  </div>
                </div>
                {(entityType === CargoModalEntityType.CARGO ||
                  entityType ===
                    CargoModalEntityType.CLIENT_CARGO_TEMPLATE) && (
                  <div className="shipment-dialog__content-right">
                    <div
                      id="shipment-dialog-section__log"
                      className="shipment-dialog__content-card"
                    >
                      <div className="shipment-dialog__log-section">
                        <div className="shipment-dialog-log-section__title">
                          {t("shipmentModal:tabs.log")}
                        </div>
                        {id ? (
                          <div className="shipment-dialog__logs-card-wrapper">
                            {mailOrdersEnabled && (
                              <MailSourceCard cargoId={id} />
                            )}
                            {scanReadingsEnabled && (
                              <ScanReadingsCard cargoId={id} />
                            )}
                            <CargoEventsShipment
                              hideTitle
                              createdByDispatcherId={userId}
                              createdAt={cargoCreatedAt}
                              cargoId={id}
                            />
                            {shouldShowCargoEventsForSplits && (
                              <CargoEventsShipmentSplits cargoId={id} />
                            )}
                          </div>
                        ) : (
                          <div className="shipment-dialog__content-card-placeholder-text">
                            {t("shipmentModal:cards.logs.availableLater")}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </FormProvider>
    </Dialog>
  );
}
